import { ChalkboardEvent, SUBTYPE } from "./utils";

const clamp01 = (v: number) => Math.max(0.02, Math.min(0.98, v));
const goalEdgeX = (team: "home" | "away") => (team === "home" ? 0.98 : 0.02);
const goalCenterY = (jitter = 0) => clamp01(0.5 + jitter);
const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
const passTo = (x: number, y: number, dx: number, dy: number) => ({
  tx: clamp01(x + dx),
  ty: clamp01(y + dy),
});

export const mockEvents: ChalkboardEvent[] = [
  {
    id: "1",
    team: "home",
    x: 0.92,
    y: 0.46,
    tx: goalEdgeX("home"),
    ty: goalCenterY(0.0),
    playerNum: 9,
    category: "Shots",
    subtype: SUBTYPE.Goals,
    minute: 5,
    playerName: "Smith",
    teamName: "Home FC",
  },
  {
    id: "2",
    team: "home",
    x: 0.74,
    y: 0.58,
    tx: goalEdgeX("home"),
    ty: goalCenterY(0.03),
    playerNum: 7,
    category: "Shots",
    subtype: SUBTYPE.ShotOnTargets,
    minute: 11,
    playerName: "Jones",
    teamName: "Home FC",
  },
  {
    id: "3",
    team: "away",
    x: 0.28,
    y: 0.62,
    tx: goalEdgeX("away"),
    ty: 0.2,
    playerNum: 10,
    category: "Shots",
    subtype: SUBTYPE.ShotOffTargets,
    minute: 17,
    playerName: "Garcia",
    teamName: "Away FC",
  },
  {
    id: "4",
    team: "away",
    x: 0.11,
    y: 0.32,
    tx: lerp(0.05, goalEdgeX("away"), 0.05),
    ty: lerp(0.32, goalCenterY(-0.02), 0.45),
    playerNum: 19,
    category: "Shots",
    subtype: SUBTYPE.BlockedShots,
    minute: 23,
    playerName: "Lopez",
    teamName: "Away FC",
  },
  {
    id: "5",
    team: "home",
    x: 0.68,
    y: 0.51,
    tx: goalEdgeX("home"),
    ty: goalCenterY(-0.015),
    playerNum: 9,
    category: "Shots",
    subtype: SUBTYPE.Goals,
    minute: 28,
    playerName: "Smith",
    teamName: "Home FC",
  },
  {
    id: "6",
    team: "home",
    x: 0.73,
    y: 0.36,
    tx: goalEdgeX("home"),
    ty: goalCenterY(-0.04),
    playerNum: 11,
    category: "Shots",
    subtype: SUBTYPE.ShotOnTargets,
    minute: 35,
    playerName: "Müller",
    teamName: "Home FC",
  },
  {
    id: "7",
    team: "away",
    x: 0.44,
    y: 0.75,
    tx: goalEdgeX("away"),
    ty: 0.84,
    playerNum: 8,
    category: "Shots",
    subtype: SUBTYPE.ShotOffTargets,
    minute: 39,
    playerName: "Kim",
    teamName: "Away FC",
  },
  {
    id: "8",
    team: "home",
    x: 0.61,
    y: 0.68,
    tx: lerp(0.61, goalEdgeX("home"), 0.35),
    ty: lerp(0.68, goalCenterY(0.02), 0.35),
    playerNum: 6,
    category: "Shots",
    subtype: SUBTYPE.BlockedShots,
    minute: 43,
    playerName: "Brown",
    teamName: "Home FC",
  },
  {
    id: "9",
    team: "home",
    x: 0.48,
    y: 0.31,
    ...passTo(0.48, 0.31, 0.12, 0.02),
    playerNum: 4,
    category: "Distribution",
    subtype: SUBTYPE.SuccessfulPasses,
    minute: 8,
    playerName: "Evans",
    teamName: "Home FC",
  },
  {
    id: "10",
    team: "home",
    x: 0.36,
    y: 0.55,
    ...passTo(0.36, 0.55, 0.1, -0.08),
    playerNum: 8,
    category: "Distribution",
    subtype: SUBTYPE.SuccessfulCrosses,
    minute: 13,
    playerName: "Taylor",
    teamName: "Home FC",
  },
  {
    id: "11",
    team: "away",
    x: 0.67,
    y: 0.77,
    ...passTo(0.67, 0.77, -0.14, -0.03),
    playerNum: 14,
    category: "Distribution",
    subtype: SUBTYPE.SuccessfulPasses,
    minute: 19,
    playerName: "Johnson",
    teamName: "Away FC",
  },
  {
    id: "12",
    team: "away",
    x: 0.72,
    y: 0.41,
    ...passTo(0.72, 0.41, -0.1, 0.06),
    playerNum: 21,
    category: "Distribution",
    subtype: SUBTYPE.UnsuccessfulPasses,
    minute: 22,
    playerName: "Martinez",
    teamName: "Away FC",
  },
  {
    id: "13",
    team: "home",
    x: 0.29,
    y: 0.29,
    ...passTo(0.29, 0.29, 0.18, 0.02),
    playerNum: 5,
    category: "Distribution",
    subtype: SUBTYPE.SuccessfulCrosses,
    minute: 25,
    playerName: "Williams",
    teamName: "Home FC",
  },
  {
    id: "14",
    team: "away",
    x: 0.87,
    y: 0.61,
    ...passTo(0.87, 0.61, -0.15, -0.06),
    playerNum: 18,
    category: "Distribution",
    subtype: SUBTYPE.UnsuccessfulPasses,
    minute: 31,
    playerName: "Lee",
    teamName: "Away FC",
  },
  {
    id: "15",
    team: "home",
    x: 0.45,
    y: 0.23,
    ...passTo(0.45, 0.23, 0.11, 0.07),
    playerNum: 3,
    category: "Distribution",
    subtype: SUBTYPE.SuccessfulPasses,
    minute: 38,
    playerName: "Clark",
    teamName: "Home FC",
  },
  {
    id: "96",
    team: "home",
    x: 0.23,
    y: 0.54,
    ...passTo(0.83, 0.54, -0.12, 0.05),
    playerNum: 2,
    category: "Distribution",
    subtype: SUBTYPE.Assists,
    minute: 41,
    playerName: "Walker",
    teamName: "Away FC",
  },
  {
    id: "97",
    team: "away",
    x: 0.63,
    y: 0.24,
    ...passTo(0.93, 0.19, -0.12, 0.05),
    playerNum: 2,
    category: "Distribution",
    subtype: SUBTYPE.KeyPasses,
    minute: 41,
    playerName: "Walker",
    teamName: "Away FC",
  },

  // Defensive
  {
    id: "17",
    team: "home",
    x: 0.28,
    y: 0.63,
    playerNum: 2,
    category: "Defensive",
    subtype: SUBTYPE.Tackles,
    minute: 15,
    playerName: "Allen",
    teamName: "Home FC",
  },
  {
    id: "18",
    team: "home",
    x: 0.35,
    y: 0.81,
    playerNum: 6,
    category: "Defensive",
    subtype: SUBTYPE.Interceptions,
    minute: 20,
    playerName: "Young",
    teamName: "Home FC",
  },
  {
    id: "19",
    team: "away",
    x: 0.75,
    y: 0.23,
    playerNum: 16,
    category: "Defensive",
    subtype: SUBTYPE.Clearances,
    minute: 27,
    playerName: "Wright",
    teamName: "Away FC",
  },
  {
    id: "20",
    team: "away",
    x: 0.81,
    y: 0.52,
    playerNum: 22,
    category: "Defensive",
    subtype: SUBTYPE.Clearances,
    minute: 33,
    playerName: "Green",
    teamName: "Away FC",
  },
  {
    id: "21",
    team: "home",
    x: 0.21,
    y: 0.73,
    playerNum: 13,
    category: "Defensive",
    subtype: SUBTYPE.Tackles,
    minute: 44,
    playerName: "King",
    teamName: "Home FC",
  },
  {
    id: "22",
    team: "away",
    x: 0.83,
    y: 0.19,
    playerNum: 20,
    category: "Defensive",
    subtype: SUBTYPE.Interceptions,
    minute: 47,
    playerName: "Scott",
    teamName: "Away FC",
  },
  {
    id: "23",
    team: "home",
    x: 0.32,
    y: 0.39,
    playerNum: 15,
    category: "Defensive",
    subtype: SUBTYPE.Clearances,
    minute: 52,
    playerName: "Hill",
    teamName: "Home FC",
  },
  {
    id: "24",
    team: "away",
    x: 0.78,
    y: 0.47,
    playerNum: 23,
    category: "Defensive",
    subtype: SUBTYPE.Clearances,
    minute: 56,
    playerName: "Adams",
    teamName: "Away FC",
  },

  // Possession
  {
    id: "25",
    team: "home",
    x: 0.15,
    y: 0.41,
    playerNum: 17,
    category: "Possession",
    subtype: SUBTYPE.DribbleSuccess,
    minute: 14,
    playerName: "Baker",
    teamName: "Home FC",
  },
  {
    id: "26",
    team: "home",
    x: 0.19,
    y: 0.58,
    playerNum: 21,
    category: "Possession",
    subtype: SUBTYPE.DribbleFail,
    minute: 18,
    playerName: "Nelson",
    teamName: "Home FC",
  },

  // Discipline
  {
    id: "33",
    team: "home",
    x: 0.44,
    y: 0.44,
    playerNum: 16,
    category: "Discipline",
    subtype: SUBTYPE.Fouls,
    minute: 21,
    playerName: "Campbell",
    teamName: "Home FC",
  },
  {
    id: "34",
    team: "home",
    x: 0.38,
    y: 0.69,
    playerNum: 19,
    category: "Discipline",
    subtype: SUBTYPE.Fouls,
    minute: 29,
    playerName: "Parker",
    teamName: "Home FC",
  },
  {
    id: "35",
    team: "away",
    x: 0.71,
    y: 0.58,
    playerNum: 13,
    category: "Discipline",
    subtype: SUBTYPE.Fouls,
    minute: 36,
    playerName: "Evans",
    teamName: "Away FC",
  },
  {
    id: "39",
    team: "home",
    x: 0.39,
    y: 0.34,
    playerNum: 20,
    category: "Discipline",
    subtype: SUBTYPE.Offsides,
    minute: 58,
    playerName: "Ward",
    teamName: "Home FC",
  },

  // Goalkeeping
  {
    id: "41",
    team: "home",
    x: 0.11,
    y: 0.51,
    playerNum: 1,
    category: "Goalkeeping",
    subtype: SUBTYPE.Saves,
    minute: 12,
    playerName: "Stewart",
    teamName: "Home FC",
  },
  {
    id: "42",
    team: "home",
    x: 0.09,
    y: 0.61,
    playerNum: 1,
    category: "Goalkeeping",
    subtype: SUBTYPE.Claims,
    minute: 16,
    playerName: "Stewart",
    teamName: "Home FC",
  },
  {
    id: "43",
    team: "home",
    x: 0.13,
    y: 0.56,
    playerNum: 1,
    category: "Goalkeeping",
    subtype: SUBTYPE.Punches,
    minute: 33,
    playerName: "Stewart",
    teamName: "Home FC",
  },
  {
    id: "44",
    team: "away",
    x: 0.91,
    y: 0.5,
    playerNum: 1,
    category: "Goalkeeping",
    subtype: SUBTYPE.Saves,
    minute: 46,
    playerName: "Bell",
    teamName: "Away FC",
  },
];
